<template>
	<div>
		<el-page-header @back="goBack" content="测评结果设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>

				<div style="margin-top: 30px">
					<el-button type="primary" plain @click="handelResultSet"
						>人格类型设置
					</el-button>
					<el-button type="primary" plain @click="handelResultContentSet"
						>内容设置
					</el-button>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div>
					<span>一级维度：</span>
					<span>
						<el-tag
							class="tag-marr"
							:key="index"
							:class="{ activeBg: dimensionInfoId == item.examDimensionId }"
							effect="plain"
							@click="activeEvent(item, 'wd')"
							v-for="(item, index) in dimensionList"
							>{{ item.name }}</el-tag
						>
					</span>
				</div>
				<div class="marr">
					<span>二级维度：</span>
					<span>
						<el-tag
							effect="plain"
							class="tag-marr"
							:class="{ activeBg1: datumId == item.code }"
							@click="activeEvent(item, 'jz')"
							:key="index"
							v-for="(item, index) in datumList"
							type="danger"
							>{{ item.name }}</el-tag
						>
					</span>
				</div>
				<div class="marr">
					<el-button @click="handleClick('add')" type="success" size="small"
						>添加结果 <i class="el-icon-plus"></i
					></el-button>
				</div>
				<div class="marr">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="resulData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="60"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="minScore"
								label="最小值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.minScore) }}
									</div>
								</template>
							</el-table-column>

							<el-table-column
								prop="maxScore"
								label="最大值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.maxScore) }}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								prop="title"
								label="标题"
								width="140"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div" v-html="scope.row.title"></div>
								</template>
							</el-table-column>
							<el-table-column
								prop="name"
								label="状态"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div" v-html="scope.row.content"></div>
								</template>
							</el-table-column>
							<el-table-column
								prop="content"
								label="说明"
								min-width="220"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ setHtmlData(scope.row.descr) }}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="100"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleClick('edit', scope.row)"
										type="primary"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!--结果设置-->
		<el-dialog
			title="结果设置"
			:visible.sync="dialogVisible"
			width="1080px"
			top="30px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="一级维度">
								<div>{{ dimensionInfo.name }}</div>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="datumInfo.name != '全部'">
							<el-form-item label="二级维度">
								<div>{{ datumInfo.name }}</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="最小值" prop="minScore">
								<el-input
									placeholder="请输入最小值"
									v-model="params.minScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="最大值" prop="maxScore">
								<el-input
									placeholder="请输入最大值"
									v-model="params.maxScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="名称" prop="title">
								<el-input
									placeholder="请输入名称"
									v-model="params.title"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="描述" prop="content">
						<rich-text
							v-if="innerVisible"
							:keyWord="'content'"
							:params="params ? params : ''"
						></rich-text>
					</el-form-item>
					<el-form-item label="解析+建议+故事分享" prop="content">
						<rich-text
							v-if="innerVisible"
							:keyWord="'descr'"
							:params="params ? params : ''"
						></rich-text>
					</el-form-item>
					<el-form-item label="隐藏的超能力" prop="content">
						<rich-text
							v-if="innerVisible"
							:keyWord="'suggest'"
							:params="params ? params : ''"
						></rich-text>
					</el-form-item>
					<el-form-item label="关注的领域" prop="content">
						<rich-text
							v-if="innerVisible"
							:keyWord="'guideSuggest'"
							:params="params ? params : ''"
						></rich-text>
					</el-form-item>
					<el-form-item label="补充字段" prop="content">
						<rich-text
							v-if="innerVisible"
							:keyWord="'suggest2'"
							:params="params ? params : ''"
						></rich-text>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";

export default {
	name: "mjywlList",
	components: {
		richText,
	},
	data() {
		return {
			emptyShow,
			isEmpty,
			detalisObj: {},
			dimensionList: [],
			params: {},
			srcList: [],
			isMoer: true,
			dimensionInfoId: "",
			dimensionInfo: {},
			datumList: [],
			datumId: "",
			datumInfo: {},
			loading: false,
			resulData: [],
			innerVisible: false,
			dialogVisible: false,
			rules: {
				minScore: [
					{
						required: true,
						message: "请输入最小值",
						trigger: "blur",
					},
				],
				maxScore: [
					{
						required: true,
						message: "请输入最大值",
						trigger: "blur",
					},
				],
			},
			languageList: [],
			languageCode: "",
			examResultId: "",
		};
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs.ruleForm.resetFields();
				this.params = {};
				this.innerVisible = false;
			}
		},
	},
	mounted() {
		this.getAppraisalData();
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question") {
				this.getDetail();
			}
		},
		async getDetail() {
			this.innerVisible = false;
			const { data: resData } = await this.$get(
				`exam/result/info/${this.examResultId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			resData.data.minScore = resData.data.minScore / 100;
			resData.data.maxScore = resData.data.maxScore / 100;
			this.params = resData.data;
			this.innerVisible = true;
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			this.getDimensionList();
		},
		/**
		 * 获取基准列表
		 */
		async getJZList() {
			this.datumList = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/datum/list`, {
				params: {
					examId: this.$route.query.examId,
					examDimensionCode: this.dimensionInfo.code,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.datumList = resData.data;
				let obj = {
					name: "全部",
					code: this.dimensionInfo.code + "1",
				};
				this.datumList.unshift(obj);
				this.datumId = this.dimensionInfo.code + "1";
				this.datumInfo = this.datumList[0];
				this.getWdResultList();
			} else {
				this.datumList = [
					{
						name: "全部",
						code: this.dimensionInfo.code + "1",
					},
				];
				this.datumId = this.dimensionInfo.code + "1";
				this.datumInfo = this.datumList[0];
				this.getWdResultList();
			}
		},
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.dimensionList = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.dimensionList = resData.data;
				if (!this.dimensionInfoId) {
					this.dimensionInfoId = resData.data[0].examDimensionId;
					this.dimensionInfo = resData.data[0];
					this.getJZList();
				}
			}
		},
		/**
		 * 维度切换
		 */
		activeEvent(item, e) {
			if (e == "wd") {
				this.dimensionInfoId = item.examDimensionId;
				this.dimensionInfo = item;
				this.getJZList();
			} else {
				this.datumId = item.code;
				this.datumInfo = item;
				this.getWdResultList();
			}
		},
		/**
		 * 结果编辑
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			this.params = {};
			this.dialogVisible = true;
			this.innerVisible = false;
			if (type == "add") {
				this.params = {};
				this.innerVisible = true;
			}
			if (type == "edit") {
				this.examResultId = row.examResultId;
				const { data: resData } = await this.$get(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				resData.data.minScore = resData.data.minScore / 100;
				resData.data.maxScore = resData.data.maxScore / 100;
				this.params = resData.data;
				this.innerVisible = true;
			}
		},
		/**
		 * 处理数据为小数
		 */
		dataHandling(data) {
			return data / 100;
		},
		/**
		 * 删除结果
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("删除成功!");
				this.getWdResultList();
			});
		},
		/**
		 * 获取测评维度结果列表
		 */
		async getWdResultList() {
			this.loading = true;
			let temp = {
				examId: this.$route.query.examId,
				examDimensionCode: this.dimensionInfo.code,
				resultType: "def",
			};
			if (this.datumInfo.name != "全部") {
				temp.examDatumCode = this.datumInfo.code;
			}
			const { data: resData } = await this.$get(`exam/result/list`, {
				params: temp,
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.resulData = resData.data;
			} else {
				this.resulData = [];
			}
		},
		/**
		 * 保存设置结果
		 */
		handleEdit() {
			if (
				parseInt(this.params.minScore * 100) >
				parseInt(this.params.maxScore * 100)
			) {
				this.$message.error("最小值不能大于最大值");
				return;
			}
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					if (this.clickType == "add") {
						this.params.examDimensionCode = this.dimensionInfo.code;
						if (this.datumInfo.name != "全部") {
							this.params.examDatumCode = this.datumInfo.code;
						}
						this.params.minScore = this.params.minScore * 100;
						this.params.maxScore = this.params.maxScore * 100;
						this.params.examId = this.$route.query.examId;
						const { data: resData } = await this.$post(
							"exam/result/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						this.examResultId = resData.data;
						this.dialogVisible = false;
						this.$message.success("添加成功!");
						this.params = {};
					} else {
						this.params.minScore = this.params.minScore * 100;
						this.params.maxScore = this.params.maxScore * 100;
						const { data: resData } = await this.$put(
							"exam/result/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						this.dialogVisible = false;
						this.$message.success("修改成功!");
					}
				});
			});
		},

		handelResultSet() {
			this.$router.push({
				name: "MJYWL_RG_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		handelResultContentSet() {
			this.$router.push({
				name: "MJYWL_RG_CT_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		goBack() {
			this.$router.back();
		},
		//过滤标签数据
		setHtmlData(str) {
			let obj = "";
			if (str) {
				obj = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
			}
			return obj;
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}

.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}

.public-dialog-form {
	height: 72vh;
	overflow-y: scroll;
}
</style>
